<template lang="pug">
#Home
  h1 hello world
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss">
#Home {
  img {
    max-width: 400px;
  }
}
</style>
